<template>
  <div class="home pagemar">
    <!--头部--->
    <HeadBar :title="config && config.matchName" needBack="false" />

    <!--焦点图--->
    <van-swipe class="my-swipe-active" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <a :href="config && config.gameLink" target="_self" rel="noopener noreferrer">
          <van-image fit="contain" :src="config && config.bannerImg" :alt="config.matchName" />
        </a>
      </van-swipe-item>
    </van-swipe>

    <!-- 功能模块 -->
    <ul class="function-bar">
      <li v-for="(item, index) in funObj" :key="index">
        <a :href="item.href">
          <van-icon class="item-icon" :name="item.icon" />
          <span>{{ item.text }}</span>
        </a>
      </li>
    </ul>

    <!-- 倒计时和报名按钮 -->
    <div class="countdown-box" id="J_countDown">
      <van-image fit="contain" :src="config && config.supportTopLogo" height="65" />
      <div v-if="ifShowCountDown">
        <div class="race-timeline-title">
          距离 {{ config && config.matchName }} 还有
        </div>
        <ul class="matchTimeBox">
          <li>
            <span id="J_day" class="time-box"> 00 </span>
            <span class="font14">天</span>
          </li>
          <li>
            <span id="J_hours" class="time-box"> 00 </span>
            <span class="font14">时</span>
          </li>
          <li>
            <span id="J_minutes" class="time-box"> 00 </span>
            <span class="font14">分</span>
          </li>
          <li>
            <span id="J_seconds" class="time-box"> 00 </span>
            <span class="font14">秒</span>
          </li>
        </ul>
      </div>
      <div v-else class="match-name-title">
        {{ config && config.matchName }}
      </div>

      <div class="matchNameBox">
        {{ config && config.supportName }}
      </div>
      <div class="submitBtn">
        <van-button v-if="ifShowCountDown" type="danger" block icon="flag-o" :url="config.gameLink">立即报名</van-button>
        <van-button v-else type="danger" block icon="flag-o" :url="config.matchResult">查询比赛成绩</van-button>
      </div>
    </div>

    <!-- 赛事公告 -->
    <ContentTitle v-if="newsList && newsList.length > 0" title="赛事公告"></ContentTitle>
    <NewsList :newsList="newsList"></NewsList>
    <van-image fit="contain" lazy-load :src="config && config.supportImg" :alt="config && config.supportName"
      class="mb-6px" />
    <!-- 版权相关 -->
    <BottomBar normal="1"></BottomBar>
    <!-- :title="config && config.matchName" -->
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import NewsList from "@/components/NewsList.vue";
  import BottomBar from "@/components/BottomBar.vue";
  import ContentTitle from "@/components/ContentTitle.vue";
  import { fetchHttp } from "@/util/fn.js";

  import { Toast, Button, Swipe, SwipeItem, Image as VanImage } from "vant";
  export default {
    name: "Home",
    components: {
      HeadBar,
      [Button.name]: Button,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [VanImage.name]: VanImage,
      NewsList,
      BottomBar,
      ContentTitle,
    },
    data() {
      return {
        matchName: "",
        matchTime: "",
        gameList: [],
        newsList: [],
        zanzhuLogo1: [],
        zanzhuLogo2: [],
        zanzhuLogo3: [],
        zanzhuLogo4: [],
        zanzhuLogo5: [],
        images: [],
        config: "",
        funObj: [
          {
            text: "报名查询",
            icon: "award",
            href: "myGame",
          },
          {
            text: "竞赛规程",
            icon: "volume",
            href: "newsDetail?newsId=122",
          },
          {
            text: "成绩查询",
            icon: "star",
            href: "newsDetail?newsId=128",
          },
          {
            text: "证书下载",
            icon: "photo",
            href: "newsDetail?newsId=131",
          },
        ],
      };
    },
    created() { },
    mounted() {
      //活动页面的配置信息
      fetchHttp("marathon/picture/matchTime", { type: 7, domain: 1 }, "GET").then(
        (res) => {
          if (res && res.code === 0) {
            let data = res.data;
            if (data) {
              let allFetchData = data.config && JSON.parse(data.config);
              this.config = allFetchData.activePage;
              this.matchName = this.config.matchName;
              //倒计时
              let matchTime = this.config.matchTime;
              setTimeout(() => {
                countDown();
              }, 2000);

              function addZero(i) {
                return i < 10 ? "0" + i : i + "";
              }
              function countDown() {
                var nowtime = new Date();
                var endtime = new Date(matchTime);
                if (nowtime > endtime) {
                  // document.getElementById('J_countDown').style.display = 'none';
                  return;
                }
                var lefttime = parseInt(
                  (endtime.getTime() - nowtime.getTime()) / 1000
                );
                var d = parseInt(lefttime / (24 * 60 * 60));
                var h = parseInt((lefttime / (60 * 60)) % 24);
                var m = parseInt((lefttime / 60) % 60);
                var s = parseInt(lefttime % 60);
                d = addZero(d);
                h = addZero(h);
                m = addZero(m);
                s = addZero(s);
                if (document.getElementById("J_day")) {
                  document.getElementById("J_day").innerHTML = d;
                  document.getElementById("J_hours").innerHTML = h;
                  document.getElementById("J_minutes").innerHTML = m;
                  document.getElementById("J_seconds").innerHTML = s;
                }
                setTimeout(countDown, 1000);
              }
            }
          }
        }
      );

      //首页新闻模块
      fetchHttp("marathon/newsHomePage", "POST").then((res) => {
        if (res && res.code === 0) {
          let newsList = res.data;
          let renderList = [];
          newsList.map((item) => {
            var newsContent = item.newsContent;
            item.newsContent = newsContent.replace(/<[^>]+>|&[^>]+;|(\n)/g, "");
            item.domain === 1 ? renderList.push(item) : "";
          });
          this.newsList = renderList;
        }
      });
    },

    computed: {
      ifShowCountDown() {
        if (+new Date() - +new Date(this.config.matchTime) > 0) {
          return false;
        } else {
          return true;
        }
      },
    },

    methods: {},
  };
</script>
<style scope lang="less">
  .pagemar {
    .match-name-title {
      font-size: 36px;
      margin: 18px 0 10px;
    }

    .logo-item {
      width: 170px;
    }

    .function-bar {
      margin-top: -6px;
    }

    .submitBtn {
      padding: 0 60px;
      display: block;
      float: left;
      width: 100%;
      margin: 20px 0 30px;
      font-size: 30px;

      .van-button--normal {
        font-size: 18px;
        font-weight: bold;
      }
    }

    .race-timeline-title {
      color: #e50021;
      font-size: 15px;
      position: relative;
      margin-left: 5%;
      margin-right: 5%;
      font-weight: 600;
      margin: 0px 10px 15px;
    }

    .race-timeline-title:before {
      content: "";
      border-top: 1px solid #e50021;
      display: block;
      position: absolute;
      width: 29px;
      top: 50%;
      left: 0;
    }

    .race-timeline-title:after {
      content: "";
      border-top: 1px solid #e50021;
      display: block;
      position: absolute;
      width: 29px;
      top: 50%;
      right: 0;
    }

    .home {
      text-align: center;
      color: #fff;
    }

    .my-swipe-active {
      min-height: 170px;

      .van-image__img {
        width: 100%;
        min-height: 170px;
      }
    }

    .my-swipe-active .van-swipe-item {
      text-align: center;
      width: 100%;
      min-height: 130px;
    }

    .countdown-main {
      background-color: #e50021;
      color: #ffffff;
      margin: 0 0 10px 0;
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .countdown-name {
      float: left;
      font-size: 20px;
      font-weight: 300;
      margin: 0 20px 0 10px;
      line-height: 40px;
    }

    .time-box {
      background-color: #e50021;
      color: #ffffff;
      font-weight: 1000;
      margin-right: 10px;
      border-radius: 4px;
      width: 50px;
      height: 50px;
      display: inline-block;
      line-height: 50px;
      text-align: center;
      font-size: 36px;
    }

    .font14 {
      color: #e50021;
      vertical-align: super;
    }

    .countdown-box {
      padding: 7px 0;
      width: 100%;
      color: #e50021;
      font-size: 20px;
      float: left;
      margin: 0;
      text-align: center;
      background: url("https://fmty-picture.oss-cn-hangzhou.aliyuncs.com/timeline.4047167e.png") no-repeat;
      background-size: contain;
      background-position: 50%;
      height: 290px;
      background-color: #dcd5d9;

      li {
        float: left;
        margin: 0px 5px 0;
        text-align: center;
        padding-top: 2px;
        line-height: 0;
        font-size: 23px;
        font-family: initial;

        p {
          margin: 15px 0;
        }
      }
    }

    .matchTimeBox {
      display: flex;
      justify-content: center;
    }

    .matchNameBox {
      font-size: 16px;
      color: #e50021;
      margin-top: 18px;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
    }

    .mainTopImg {
      height: 220px;
      display: block;
      overflow: hidden;
    }

    .mb-6px {
      margin-bottom: -6px;
    }
  }
</style>